import $ from 'jquery'

class About{

  constructor() {
    this.init()
  }


  init() {
    this.addEvents()
  }

  addEvents() {

    //console.log('haha');

    this.input = $('.newsletter-input')
    this.form = $('.newsletter-form')
    this.footermessage = $('.newsletter-message')
    this.video = $('.video-link')

    // this.input.on('input', (e)=>{
    //   const active = this.validateEmail(this.input.val())
    //   $('.footer__newsletter').toggleClass('is-active', active)
    // })

    this.video.on('click', (e)=>{
      e.preventDefault();
      $('.modal').addClass('is-visible')
      var videoid = $(e.currentTarget).data('video')
      $('.video-container').append(`<iframe width="560" height="315" src="https://www.youtube.com/embed/${videoid}?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`)
        if (window.gtag) {
            gtag('event', 'video', {'method': 'youtube'});
        }
    })

    $('.modal').on('click', (e)=>{
      e.preventDefault();
      $('.modal').removeClass('is-visible')
      $('.video-container').html('')
    })


    this.form.on('submit', (e)=>{
        e.preventDefault()
        const form = $(e.currentTarget)
        const url = form.attr('action')
        const email = form.find('.newsletter-input').val()
        //$('.footer__newsletter').addClass('is-sending')
        $('.newsletter-submit').attr('disabled', true)

        this.mailchimp(email, url).done(
          (data) => {
            if (data.result != "success") {
                //$('.footer__newsletter').removeClass('is-sending').addClass('is-error')
                this.footermessage.html(data.msg)
                this.footermessage.one('click', (e)=>{
                    $('.newsletter-submit').attr('disabled', false)
                    //$('.footer__newsletter').removeClass('is-error')
                })
            } else {

                //$('.footer__newsletter').removeClass('is-sending').addClass('is-success')
                $('.newsletter-submit').attr('disabled', false)
                form.find('.newsletter-input').val('')
                this.footermessage.html(data.msg)
            }
        }).fail(
          (err) => {
              //console.log('err', err);
              //$('.footer__newsletter').removeClass('is-sending').addClass('is-error')
              this.footermessage.html(err.msg)
              this.footermessage.one('click', (e)=>{
                  $('.newsletter-submit').attr('disabled', false)
                  //$('.footer__newsletter').removeClass('is-error')
              })
          }
        )
    })
  }

  validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  mailchimp(email, url) {

		var data = {
			'EMAIL': email,
			utf8: '✓'
		};

		var promise = $.ajax({
				url: url ,
				method: 'post',
				data: data,
				cache       : false,
				dataType    : 'jsonp',
				jsonp: 'c',
				contentType: "application/json; charset=utf-8"
		})

		return promise;
	}

  destroy(){


  }

}

module.exports = About
